import { render, staticRenderFns } from "./DialogRecommended.vue?vue&type=template&id=381747b0&scoped=true"
import script from "./DialogRecommended.vue?vue&type=script&lang=js"
export * from "./DialogRecommended.vue?vue&type=script&lang=js"
import style0 from "./DialogRecommended.vue?vue&type=style&index=0&id=381747b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381747b0",
  null
  
)

export default component.exports